<template>
  <div>
    <div class="pdf-preview" v-if="pdfFile">
      <button @click.self="closePreview()">
        &times;
    </button>

    <iframe
      :src="pdfFile"
      width="100%"
      height="100%"
    />
    </div>
    <div v-show="false">
      <div ref="testHtml" class="mx-5 my-4">
        <div class="pdf-item mb-3 text-center">
              <img
                src="../assets/Marley_Logo.png"
                alt="boat Logo"
                style="flex: none;"
              />
              <!-- <h3
              class="text-sm font-weight-bold text-gray-600 text-monospace"
              >
                MARLEY
                <br/>
                SHIPPING
              </h3> -->
        </div>
        <div class="pdf-item mb-3 d-flex text-sm justify-content-between font-weight-bold">
          <div>
              BL
              <span class="mr-4"> {{ response.fileno }}</span>
          </div>
          <div>
             Date
              <span>{{ new Date().toDateString() }}</span>
          </div>
        </div>
        <div class="pdf-item mb-2">
          <table class="table table-bordered text-sm w-100">
            <tr>
              <td>
                Booking:  {{ response.billOfLading }}
                <br/>
                Vessel: {{ response.vessel }}
                <br/>
                ITN: {{ response.aesITN }}
                <br/>
                Carrier: {{ response.exportingCarriage }}
                <br/>
                SCAC: {{ response.exportingScac }}
                <br/>
                <div v-if="response.items.container.length">
                  <tr v-for="item in response.items.container"
                  :key="item.id">
                    Weight: {{ sumItem(item)  }}
                    <br/>
                    Seal: {{ item.containerSeal }}
                    <br/>
                    Container: {{ item.name }}
                    <br/>
                  </tr>
                </div>
                <div v-else>
                  Weight:
                  <br/>
                  Seal:
                  <br/>
                  Container:
                  <br/>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="pdf-item mb-2">
          <table class="table table-bordered text-sm w-100">
            <tr>
              <td>
                <u>Shipper</u>
                <br/>
                Name: {{ `${response.exporterFirstName} ${response.exporterLastName}` }}
                <br/>
                Address: {{ response.exporterAddress }}
                <br/>
                City: {{ response.exporterCity }}
                <br/>
                State: {{ response.exporterState }}
                <br/>
                Zip code: {{ response.exporterZipCode }}
                <br/>
                Telephone: {{ response.exporterPhone }}
                <br/>
                E-mail: {{ response.exporterEmail }}
                <br/>
              <br/>
                <u>Consignee</u>
                <br/>
                Name: {{ `${response.importerFirstName} ${response.importerLastName}` }}
                <br/>
                Address: {{ response.importerAddress }}
                <br/>
                City: {{ response.importerCity }}
                <br/>
                State: {{ response.importerState }}
                <br/>
                Zip code: {{ response.importerZipCode }}
                <br/>
                Telephone: {{ response.importerPhone }}
                <br/>
                E-mail: {{ response.importerEmail }}
                <br/>
              <br/>
                <u>Notify Party and email BL Release</u>
                <br/>
                Name: {{ `${response.notifyPartyFirstName} ${response.notifyPartyLastName}` }}
                <br/>
                Address: {{ response.notifyPartyAddress }}
                <br/>
                City: {{ response.notifyPartyCity }}
                <br/>
                State: {{ response.notifyPartyState }}
                <br/>
                Zip code: {{ response.notifyPartyZipCode }}
                <br/>
                Telephone: {{ response.notifyPartyPhone }}
                <br/>
                E-mail: {{ response.notifyPartyEmail }}
                <br/>
                </td>
            </tr>
          </table>
        </div>
        <div class="html2pdf__page-break" />
        <div class="pdf-item mt-4 mb-2">
          <table class="table table-bordered text-sm w-100">
            <tr>
              <td>
                <u>City of Loading</u>
                <br/>
                {{ response.loadingPort }}
                <br/>
                {{ response.origin }}
                <br/>
                <u>Destination Port</u>
                <br/>
                {{ response.unloadingPort }}
                <br/>
                 {{ response.destination }}
              </td>
            </tr>
          </table>
        </div>
        <div class="pdf-item mb-2">
          <table class="table table-bordered text-sm w-100">
            <tr>
              <td>
                Payment
                <br/>
                <!-- All Freight Prepaid
                Panamerican Shipping
                144-52 225th St
                Jamaica, NY 11413
                718-636-4813 -->
              </td>
            </tr>
          </table>
        </div>
        <div class="pdf-item mb-2">
          <table class="table table-bordered text-sm w-100">
              <tr>
                <th>QTY</th>
                <th>COMMODITIES</th>
                <th>DESCRIPTION</th>
              </tr>
              <tr v-for="item in response.warehouseItems"
                :key="item.id">
                <th>{{ item.qty }}</th>
                <th>{{ item.commodity }}</th>
                <th>{{ item.description }}</th>
              </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';

export default {
  name: 'PanBL',
  props: [
    'name',
    'response',
  ],
  data() {
    return {
      pdfFile: null,
    };
  },
  computed: {
    hazardous() {
      return this.response.itemDetails.items.reduce((acc, item) => acc || item.hazardous, false);
    },
  },
  methods: {
    sumItem(container) {
      return container.item.reduce(
        (accumulator, currentValue) => accumulator + currentValue.weight,
        0,
      );
    },
    closePreview() {
      this.pdfFile = null;
    },
    generatePdf() {
      /* eslint new-cap: ["error", { "newIsCap": false }] */
      // const doc = new jsPDF('p', 'pt', 'A4');
      // const margins = {
      //   top: 80,
      //   bottom: 60,
      //   left: 40,
      //   width: 522,
      // };

      // doc.html(this.$refs.testHtml, { left: margins.left, width: margins.width }).then(() => {
      //   doc.output('dataurlnewwindow');
      // });

      html2pdf().from(this.$refs.testHtml).set().output('bloburl')
        .then((ref) => {
          this.pdfFile = ref;
        });
    },
  },
  filters: {
    toCurrency(value) {
      if (typeof value !== 'number') {
        return value;
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
};
</script>

<style lang="scss" scoped>
li:not(:last-child) {
    margin-bottom: 5px;
}
.table-bordered td, .table-bordered th {
  border: 1px solid #343434;
}

.pdf-preview {
  position: fixed;
  width: 65%;
  min-width: 600px;
  height: 80vh;
  top: 100px;
  z-index: 9999999;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 5px;
  box-shadow: 0px 0px 10px #00000048;

  button {
    position: absolute;
    top: -20px;
    left: -15px;
    width: 35px;
    height: 35px;
    background: #555;
    border: 0;
    box-shadow: 0px 0px 10px #00000048;
    border-radius: 50%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
  }

  iframe {
    border: 0;
  }
}

</style>
